<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
      <admin-sidebar-menu v-if="admin" />

      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Group : {{groupName}}</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <b-card no-body>
            <b-tabs card>
              <b-tab title="INSTRUCTORS" @click="selected_component('Instructorlists')" v-bind:active="isActive('Instructorlists')">
              </b-tab>
              <b-tab title="STUDENTS" @click="selected_component('Studentlists')" v-bind:active="isActive('Studentlists')">
              </b-tab>
              <component :is="selectedComponent" :groupId="groupId">
              </component>

            </b-tabs>
          </b-card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import Instructorlists from './instructorlists.vue';
import Studentlists from './studentlists.vue';
import store from '../../store/store.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';

export default {
    data() {
          return {
            selectedComponent: 'instructorlists',
            groupId: this.$route.params.group_id,
            groupName: '',
            admin: false,
          }
    },
    components: {
          UserMenu,
          GoBack,
          Instructorlists,
          Studentlists,
          AdminSidebarMenu
    },
    methods: {
         isActive: function (tabvalue) {
              return this.selectedComponent === tabvalue
         },
         selected_component: function (tabvalue) {
            this.selectedComponent = tabvalue;
            let page_url = 'GroupUsers';
            let active_tab = tabvalue;
            this.$store.dispatch('active_tab', { page_url, active_tab })
         },
         getGroupName() {
            axios.get('/group_name/' + this.groupId, {

            })
            .then(response =>  {
                this.groupName = response.data;
            })
            .catch(function(error) {

            });
         }
    },
    created() {
      if((this.$store.state.page_url) && (this.$store.state.page_url === 'GroupUsers')) {
        this.selectedComponent = this.$store.state.active_tab;
      }
      var roles = this.$store.state.roles;
      if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
        this.admin = true;
      }
      this.getGroupName();
      axios.get('/get_account_id', {
      })
      .then(response =>  {
        this.$store.dispatch('set_user_accountid', response.data);
      })
      .catch(function(error) {

      });

    }
}
</script>

<style>
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.assigntask-action-btn {
  width: 120px;
}
.card-body {
    padding: 0px;
}
.card-header { padding-top: 0px; }

hr {
  margin: 10px 0px;
}
.mentee_name {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/primaryadmin/group_users.vue